const TabCustomFields = () => {
   return (
      <div className="col-sm-12 p-none">
         <div className="box">
            <div className="content-child">
               <div className="main-content content t0">
                  <div className="pd-all-20 cuf-section">
                     {/* <h5 className="mb20 clearfix"><span className="pull-left text-bigger mt8">Custom Field<a
                        href="https://support.harasocial.com/support/solutions/articles/42000087076" target="_blank"> <i
                           className="icon-help">
                        </i></a></span><a className="pull-right btn btn-primary" type="button"
                           style={{
                              position: 'relative',
                              fontSize: 14,
                              color: 'white',
                              fontWeight: 600,
                              padding: '10px 12px',
                              lineHeight: '14px',
                              height: 36,
                           }}>Tạo mới Custom Field</a></h5> */}
                     <div>
                        <div className="">
                           <div className="table-wrapper scroll-light">
                              <table className="app-v2-table ">
                                 <thead className="app-v2-table-thead">
                                    <tr className="app-v2-table-tr">
                                       <th className="app-v2-table-th" style={{ width: 330 }}>Tên thuộc tính</th>
                                       <th className="app-v2-table-th" style={{ width: 170 }}>Kiểu dữ liệu</th>
                                       <th className="app-v2-table-th">Mô tả</th>
                                       <th className="text-right-i app-v2-table-th" style={{ width: 100 }}>Lưu trữ</th>
                                    </tr>
                                 </thead>
                                 <tbody className="app-v2-table-tbody">
                                    <tr className="pointer app-v2-table-tr">
                                       <td className="text-left app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 reply-message text-smaller h-40 display-flex">
                                             <input type="text" placeholder="" className="" value="Số điện thoại" /></div>
                                       </td>
                                       <td className="app-v2-table-td">Chuỗi ký tự</td>
                                       <td className="app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 text-description h-40 display-flex">
                                             <input type="text" placeholder="Thêm mô tả" className="" value="" /></div>
                                       </td>
                                       <td className="text-right-i app-v2-table-td">
                                          <a>
                                             <i>
                                                <svg ariaHidden="true" focusable="false"
                                                   dataprefix="far" dataicon="arrow-alt-circle-down"
                                                   className="svg-inline--fa fa-arrow-alt-circle-down fa-w-16 " role="img"
                                                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 14 }}>
                                                   <path fill="currentColor"
                                                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z">
                                                   </path>
                                                </svg>
                                             </i>
                                          </a>
                                       </td>
                                    </tr>
                                    <tr className="pointer app-v2-table-tr">
                                       <td className="text-left app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 reply-message text-smaller h-40 display-flex">
                                             <input type="text" placeholder="" className="" value="Họ và Tên" /></div>
                                       </td>
                                       <td className="app-v2-table-td">Chuỗi ký tự</td>
                                       <td className="app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 text-description h-40 display-flex">
                                             <input type="text" placeholder="Thêm mô tả" className="" value="" /></div>
                                       </td>
                                       <td className="text-right-i app-v2-table-td">
                                          <a>
                                             <i>
                                                <svg ariaHidden="true" focusable="false"
                                                   dataprefix="far" dataicon="arrow-alt-circle-down"
                                                   className="svg-inline--fa fa-arrow-alt-circle-down fa-w-16 " role="img"
                                                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 14 }}>
                                                   <path fill="currentColor"
                                                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z">
                                                   </path>
                                                </svg>
                                             </i>
                                          </a>
                                       </td>
                                    </tr>
                                    <tr className="pointer app-v2-table-tr">
                                       <td className="text-left app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 reply-message text-smaller h-40 display-flex">
                                             <input type="text" placeholder="" className="" value="Đánh giá" /></div>
                                       </td>
                                       <td className="app-v2-table-td">Chuỗi ký tự</td>
                                       <td className="app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 text-description h-40 display-flex">
                                             <input type="text" placeholder="Thêm mô tả" className="" value="" /></div>
                                       </td>
                                       <td className="text-right-i app-v2-table-td">
                                          <a>
                                             <i>
                                                <svg ariaHidden="true" focusable="false"
                                                   dataprefix="far" dataicon="arrow-alt-circle-down"
                                                   className="svg-inline--fa fa-arrow-alt-circle-down fa-w-16 " role="img"
                                                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 14 }}>
                                                   <path fill="currentColor"
                                                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z">
                                                   </path>
                                                </svg>
                                             </i>
                                          </a>
                                       </td>
                                    </tr>
                                    <tr className="pointer app-v2-table-tr">
                                       <td className="text-left app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 reply-message text-smaller h-40 display-flex">
                                             <input type="text" placeholder="" className="" value="Đã tham gia" /></div>
                                       </td>
                                       <td className="app-v2-table-td">Chuỗi ký tự</td>
                                       <td className="app-v2-table-td">
                                          <div
                                             className="input-text input-text-none-scrollbar text-single font-size-14 text-description h-40 display-flex">
                                             <input type="text" placeholder="Thêm mô tả" className="" value="" /></div>
                                       </td>
                                       <td className="text-right-i app-v2-table-td">
                                          <a>
                                             <i>
                                                <svg ariaHidden="true" focusable="false"
                                                   dataprefix="far" dataicon="arrow-alt-circle-down"
                                                   className="svg-inline--fa fa-arrow-alt-circle-down fa-w-16 " role="img"
                                                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 14 }}>
                                                   <path fill="currentColor"
                                                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z">
                                                   </path>
                                                </svg>
                                             </i>
                                          </a>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div></div>
      </div>
   )
}

export default TabCustomFields;